<template>
    <div
        ref="container"
        style="width: 100%; height: 100%; overflow-y: auto; font-size: 8pt"
        class="scrollbar-hidden"
    >
        <svg
            :id="container.id"
            ref="containerSvg"
            class="designer-container"
            :height="container.height"
            :width="container.width"
            :style="{ transform: `scale(${preview ? 1 : 1})`, 'transform-origin': 'top left' }"
        >
            <rect
                x="0"
                y="0"
                width="100%"
                height="100%"
                :fill="
                    !preview && container.boxStyle && !container.boxStyle.fill
                        ? 'rgba(255, 241, 211, 0.3)'
                        : 'transparent'
                "
                :stroke="!preview ? 'whitesmoke' : container.boxStyle.stroke"
                stoke-width="0.5"
                :style="{ filter: !preview ? 'none' : 'none' }"
            />
            <g>
                <rect
                    :id="cell.id"
                    class="grid-cell"
                    v-for="cell of container.gridCells"
                    :key="cell.id"
                    :x="cell.x"
                    :y="cell.y"
                    :width="cell.width"
                    :height="cell.height"
                    stroke="whitesmoke"
                    stoke-width="0.5"
                    fill="transparent"
                    style="border-collapse: collapse"
                    :visibility="preview ? 'hidden' : 'visible'"
                />
            </g>
            <g>
                <BoxComponent
                    v-for="box of visibleBoxes"
                    :key="box.id"
                    :box="box"
                    :preview="preview"
                    :selected="isBoxSelected(box)"
                    :selectedBoxObj="selectedBoxObj"
                    @selected-box="handleSelectedBox($event)"
                    ref="gridBoxComponent"
                />
                <!-- <BoxComponent v-for="box of container.children" 
                    :key="box.id" 
                    :box="box"
                    selected="isBoxSelected(box)"
                    selected-box="handleSelectedBox($event)"
                    moved-box="() => {}"
                    :preview="preview"
                    ref="boxComponent"
                >
                </BoxComponent> -->
            </g>
        </svg>
    </div>
</template>
<script lang="ts">
import { Box, GridContainer, Layout, TextFieldBox } from "../models";
import BoxPopupMenu from "../BoxPopupMenu.vue";
import { Prop } from "vue-facing-decorator";
import { Watch } from "vue-facing-decorator";
import { Component, Vue, toNative } from "vue-facing-decorator";

// import BoxComponent from "../BoxComponent.vue"

// TODO: handle the case where the component is dragged out of the container... OK but may need improvements
// TODO: handle snapping in cells OK
// TODO: handle resizing OK
// TODO: handle container cloning  OK
// TODO: add container properties and styling  OK

@Component({
    components: {
        BoxPopupMenu,
        // BoxComponent
    },
})
export class GridBox extends Vue {
    @Prop({ required: true }) container: GridContainer;
    @Prop({ required: false }) preview: boolean;
    @Prop({ required: false, type: Box, default: null }) selectedBoxObj: Box;

    get visibleBoxes() {
        if (!this.container?.children?.length) {
            return [];
        }
        return this.container.children.filter((x) => x.visible);
    }

    @Watch("selectedBox")
    watch_selectedBox(newVal: Box) {
        console.log("Selected box in GridBox", this.selectedBoxObj);
    }

    isBoxSelected(box: Box) {
        return this.selectedBoxObj ? this.selectedBoxObj?.id === box?.id : false;
    }

    propagateEmit(event: string, ...paylaods) {
        // let vm = this as Vue;
        let vm = this as any;
        while (vm) {
            vm.$emit(event, ...paylaods);
            if (vm.$refs.boxComponent) break;
            vm = vm.$parent;
        }
    }

    handleSelectedBox(box) {
        // this.selectedBox = box
        this.propagateEmit("selected-box", box);
        console.log("propagateEmit selected-box", box);
    }

    @Watch("container.properties.nRows")
    @Watch("container.properties.nCols")
    @Watch("container.properties.matchCellWidth")
    @Watch("container.properties.matchCellHeight")
    @Watch("container.properties.overflowCell")
    @Watch("container.properties.cellPadding")
    @Watch("container.properties.childrenMatchWidth") // For SimpleContainer class
    onRowsOrColsChange() {
        this.container.buildGrid(/*true*/);
    }
}

export default toNative(GridBox);
</script>
<style lang="css" scoped></style>
